'use strict';

$(document).ready
(
    function()
    {
        let sidebar = $('.ui.sidebar');
        let datatable = $('div.datatable:not(.ajax)');
        let popup = $('*[data-content]');

        if(sidebar.length &&
            $('.toc.item').length) sidebar.sidebar('attach events', '.toc.item');

        if(datatable.length) datatable.find('table').DataTable();
        if(popup.length) popup.popup();

        $('.tabular.menu .item').tab();

        modalShow();
    }
);

function modalShow()
{
    let button;
    let modalConfirm = $('.ui.modal.confirm');

    let modalConfirmContent = modalConfirm.find('.content.text');
    let modalConfirmYes = modalConfirm.find('.yes');

    $(document).on('click', 'A.red.destroy, INPUT[type="submit"].destroy',
        function()
        {
            button = $(this);

            modalConfirmContent.html('Are you sure that you want to delete this record?');
            modalConfirm.modal('show');

            return false;
        }
    );

    modalConfirmYes.click
    (
        function()
        {
            if(button.attr('href')) location.href = button.attr('href');
            else if(button.parents('FORM').length) button.parents('FORM').get(0)
            .submit();
        }
    );
}